// store.js
import {reactive} from 'vue'
import {Models, OrderType} from './models'

const Department: Models.DepartmentType = {
    id: 0,
    name: "",
    email: "",
    deleted: false,
}    

const DepartmentDefault: Models.DepartmentType = {
    id: 1,
    name: "",
    email: "",
    deleted: false,
} as const; 

const User: Models.UserType = {
    id: 0, 
    admin: false,
    firstName: "",
    lastName: "",
    department: {...Department},
    company: "",
    phone: "",
    email: "",
    lastLoginIp: "",
    lastLoginTime: new Date(),
    active: true,
  
};

const CurrentState: Models.OrderState = {
    id: 0,
    name:  "",
    color: "", 
    active: true,
};

const Supplier: Models.SupplierType = {
    id: 0,
 //   firstName: "",
 //   lastName: "",
    company: "",
}

const Mark: Models.MarkType = {
    id: 0,
    name:  "",
    color: "", 
    active: true,
};

const CurrentStateDefault: Models.OrderState = {
    id: 1,
    name:  "Nová",
    color: "#2f4cf5", 
    active: true,
} as const; 

const OrderHistory: Models.OrderHistory[] = [];
const OrderStates: Models.OrderState[] = [];
const Marks: Models.MarkType[] = [];
const Suppliers: Models.SupplierType[] = [];
const StockMovements: any[] = [];

const EmailHistories: Models.EmailHistory[] = [];
const EmailRecipients: Models.EmailRecipient[] = [];
const EmailRecipientOptions: any[] = [];
const AttTypes: any[] = [];

const Customer: Models.CustomerType = {
    id: 0,
    firstName: "",
    lastName: "",
    company: "",
    ico: "",
    vat: "",
    email: "", 
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    zip: "",
    comment: "",

}

const CustomerDefault: Models.CustomerType = {
    id: 0,
    firstName: "",
    lastName: "",
    company: "",
    ico: "",
    vat: "",
    email: "", 
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    zip: "",
    comment: "",

} as const

const Order: OrderType = {
    id: 0,
    uuid: "",
    currentState: {...CurrentState} ,
    orderCode: 0,
    source: "",
    description: "",
    customer: {...Customer},
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    modifiedAt: new Date(), 
    department: {...Department},
    modifiedUser: {...User}
    //deleted: false,
};

const OrderDefault: OrderType = {
    id: 0,
    uuid: "",
    currentState: {...CurrentStateDefault} ,
    orderCode: 0,
    description: "",
    source: "",
    customer: {... CustomerDefault},
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    department: {...DepartmentDefault},
    deleted: false,
    modifiedUser: {...User}
} as const;

const EmailHistory: Models.EmailHistory = {
    id: 0,
    order:  {...Order},
    whom: "",
    subject: "",
    createDate: new Date(),
    user: {...User},
}

const EmailRecipient: Models.EmailRecipient = {
    id: 0,
    name: "",
    email: "",
    glassType: "",
}    

const EmailRecipientOption: any = {
    id: 0,
    name: "",

}    

const API_URL = process.env.VUE_APP_API_URL;


const HasBeenSent = false;
const HasBeenInProduction = false;
const HasBeenReady = false;
const HasBeenFinished = false;
const HasBeenEmailSent = false;

const BasicUrlMessage = "/v1/message?sortby=createdAt&order=desc&query=deleted:0,received:1" as const
const BasicUrlFilterMessages = "/v1/data-filter?sortby=createdAt&order=desc&query=deleted:0,received:1" as const
const BasicUrlFilterOrders = "/v1/data-filter?sortby=id&order=desc&query=deleted:0" as const
const BasicUrlDownloadLink = API_URL + "/download/"
const BasicUrlFilterCommunication = "/v1/data-filter?sortby=createdAt&order=desc&query=deleted:0" as const
const BasicUrlFilterProducts = "/v1/data-filter?sortby=id&order=desc&query=deleted:0" as const
const BasicUrlFilterStockItems = "/v1/data-filter?sortby=id&order=desc&query=deleted:0,eliminated:0" as const
const BasicUrlReservationRequests = "/v1/reservation-request?sortby=id&order=desc&query=deleted:0" as const
const BasicUrlSprayingRequests = "/v1/spraying-request?sortby=id&order=desc&query=deleted:0" as const

export const store = reactive({
    Api_url: API_URL,
    token: "",
    admin: false,
    
    user: {...User},
    modifiedUser: {...User},

    order: {...Order},
    order_default: {...OrderDefault},

    customer: {... Customer},
    customer_default: {... CustomerDefault},

    orderHistory: OrderHistory,
    hasBeenSent: HasBeenSent,
    hasBeenInProduction: HasBeenInProduction,
    hasBeenReady: HasBeenReady,
    hasBeenFinished: HasBeenFinished,
    hasBeenEmailSent: HasBeenEmailSent,
    orderStates: OrderStates,
    emailHistory: EmailHistory,
    emailRecipient: EmailRecipient,   
    emailHistories: EmailHistories,
    emailRecipients: EmailRecipients,
    emailRecipientOption: EmailRecipientOption,
    emailRecipientOptions: EmailRecipientOptions,
    emailLink: "",
    isSendEmail: false,
    basicUrlMessage: BasicUrlMessage,
    basicUrlFilterMessages: BasicUrlFilterMessages,
    basicUrlFilterOrders: BasicUrlFilterOrders,
    totalRecords: 0,
    suppliers: Suppliers,
    marks: Marks,
    basicUrlDownloadLink: BasicUrlDownloadLink,
    basicUrlFilterCommunication: BasicUrlFilterCommunication,
    selectModul: "",
    basicUrlFilterProducts: BasicUrlFilterProducts,
    basicUrlFilterStockItems: BasicUrlFilterStockItems,
    stockMovements: StockMovements,
    attTypes: AttTypes,
    basicUrlReservationRequests: BasicUrlReservationRequests,
    basicUrlSprayingRequests: BasicUrlSprayingRequests,
});